import {
  getRequiredPermissionForPath,
  hasPermission,
} from '../constants/permissions';
import { moduleCodeForPath, isPathAllowedBySubscription } from './subscriptionModules';
import {
  isConsultoriaHiddenPath,
  isConsultoriaTenant,
  isRequesterHiddenPath,
} from './tenantProfile';

/**
 * Mesma regra do Layout e do menu: RBAC + assinatura + perfil do tenant.
 * @param {string} path
 * @param {{
 *   permissions?: string[],
 *   tenant?: object | null,
 *   user?: object | null,
 *   moduleSet?: Set<string> | null,
 *   subscriptionReady?: boolean,
 * }} ctx
 */
export function canAccessRoute(path, ctx = {}) {
  const {
    permissions = [],
    tenant = null,
    user = null,
    moduleSet = null,
    subscriptionReady = true,
  } = ctx;

  if (!hasPermission(permissions, getRequiredPermissionForPath(path))) return false;
  if (isConsultoriaHiddenPath(path, tenant)) return false;
  if (isRequesterHiddenPath(path, user)) return false;
  if (pathMatches(path, '/portfolio') && !isConsultoriaTenant(tenant)) return false;

  const needModule = moduleCodeForPath(path);
  if (!subscriptionReady && needModule !== 'base') return false;
  if (subscriptionReady && !isPathAllowedBySubscription(path, moduleSet)) return false;
  return true;
}

function pathMatches(pathname, prefix) {
  const raw = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return raw === prefix || raw.startsWith(`${prefix}/`);
}

export function isSubscriptionPending(path, subscriptionReady) {
  return !subscriptionReady && moduleCodeForPath(path) !== 'base';
}
